export default "__VITE_ASSET__62c02c7c__"